import { MuiOtpInput } from 'mui-one-time-password-input'
import { Box, Button, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { authService } from '../../../services/authService'
import { toast } from 'react-toastify'
import { STAGES } from '../Signup'
import { isValidEmail } from '../../../utility/validator'

const VerifyOTP = ({ userDetails, setUserDetails, isLoading, navigateToScreen }) => {
  const [error, setError] = useState('')

  useEffect(() => {
    ;(async () => {
      if (userDetails?.otp?.length == 6) {
        const res = await authService.verifyOnboardingOtp({
          email: userDetails.email,
          otp: userDetails.otp,
        })
        if (res.status) {
          navigateToScreen(STAGES.ENTER_USER_DETAILS)
          setUserDetails({ ...res.user, ...userDetails, is_new_user: res.is_new_user })
        } else {
          setError(res.message)
        }
      }
    })()
  }, [userDetails.otp])

  const handleVerifyOtp = async (e) => {
    e.preventDefault()
    const res = await authService.verifyOnboardingOtp({
      email: userDetails.email,
      otp: userDetails.otp,
    })
    if (res.status) {
      navigateToScreen(STAGES.ENTER_USER_DETAILS)
      setUserDetails({
        ...res.user,
        ...userDetails,
        is_new_user: res.is_new_user,
      })
    } else {
      // show the error
      toast.error('Something went wrong!')
    }
  }

  const resendOtp = async () => {
    if (!isValidEmail(userDetails.email)) {
      return
    }

    // create user and send otp just with email
    const res = await authService.sendOnboardingOtp({ email: userDetails.email })
    if (res.status) {
      navigateToScreen(STAGES.VERIFY_EMAIL)
    } else {
      // show the error
      toast.error('Something went wrong!')
    }
  }

  return (
    <Box
      component="form"
      className="onboardingForm"
      onSubmit={handleVerifyOtp}
      style={{
        marginBottom: 16,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        background: ' #fff',
        borderRadius: 12,
        boxShadow: '0 24px 64px #26214a1a',
        padding: '60px 60px',
      }}
    >
      <Typography
        variant="h5"
        color="textSecondary"
        style={{
          color: '#27104E',
          fontSize: '21px',
          marginBottom: '10px',
          fontWeight: '800',
        }}
      >
        Verify Your Email
      </Typography>
      <Typography
        style={{ marginBottom: '30px', color: '#4E62BB', fontSize: '12px', textAlign: 'center' }}
      >
        We've sent a 6-digit verification code to your email <b>{userDetails.email}</b>.
      </Typography>

      <MuiOtpInput
        autoFocus
        style={{ marginBottom: 32 }}
        length={6}
        value={userDetails.otp}
        onChange={(otp) => setUserDetails({ ...userDetails, otp: otp })}
      />

      <Typography
        style={{ marginBottom: 24, fontSize: 11, cursor: 'pointer' }}
        color="primary"
        onClick={resendOtp}
      >
        Didn't receive the code? <span style={{ fontWeight: 600 }}>Resend OTP</span>
      </Typography>

      {error && (
        <Typography
          variant="caption"
          color="text.error"
          textAlign="center"
          style={{ marginBottom: 12 }}
        >
          {error}
        </Typography>
      )}

      <Box style={{ display: 'flex', alignItems: 'center', gap: 24, width: '100%' }}>
        <Button
          fullWidth
          disabled={isLoading}
          variant="outlined"
          className="onboarding-btn"
          onClick={() => navigateToScreen(0)}
          sx={{
            borderRadius: '9px',
            color: 'text.primary',
            borderColor: 'border.secondary',
            outlineColor: 'border.secondary',
          }}
        >
          Go Back
        </Button>
        <Button
          fullWidth
          disabled={isLoading}
          color="primary"
          variant="contained"
          className="onboarding-btn"
          onClick={handleVerifyOtp}
          style={{ borderRadius: '9px' }}
          type="submit"
        >
          Verify OTP
        </Button>
      </Box>
    </Box>
  )
}

export default VerifyOTP
